module.exports = __webpack_public_path__ + "eb567c06cbb4424427ba65be5a7fc268.fbx";